import { videoCompleteData, videoErrorData, videoProgressData, videoStartData } from '../tracking-constants/video';
import { timestamp } from '../../utils';
import { Video, VideoEvent } from '../types';

export const videoStart = (data: Video): VideoEvent => ({
  event: 'videoStart',
  timestamp: timestamp(),
  content: {
    video: videoStartData(data),
  },
});

export const videoComplete = (data: Video): VideoEvent => ({
  event: 'videoComplete',
  timestamp: timestamp(),
  content: {
    video: videoCompleteData(data),
  },
});

export const videoProgress = (data: Video): VideoEvent => ({
  event: 'videoProgress',
  timestamp: timestamp(),
  content: {
    video: videoProgressData(data),
  },
});

export const videoError = (data: Video): VideoEvent => ({
  event: 'videoError',
  timestamp: timestamp(),
  content: {
    video: videoErrorData(data),
  },
});
